import { ref } from "vue";

const DEFAULT_DURATION_MS = 200;

/**
 * Soft-delete helper for table rows.
 *
 * Marks rows as "removing" so the CSS .rf-row-removing leave-transition can
 * play, then runs the actual delete action, then clears only the ids owned
 * by this call (safe for concurrent deletes). Bind with:
 *   :class="{ 'rf-row-removing': isRemoving(item.id) }"
 *
 * Duration must match the CSS transition duration in RfTable.vue.
 */
export function useRowRemoval(durationMs = DEFAULT_DURATION_MS) {
  const removingIds = ref(new Set());

  const isRemoving = id => removingIds.value.has(id);

  const removeWithFade = async (ids, action) => {
    const next = new Set(removingIds.value);
    ids.forEach(id => next.add(id));
    removingIds.value = next;
    try {
      await new Promise(resolve => setTimeout(resolve, durationMs));
      return await action();
    } finally {
      const restored = new Set(removingIds.value);
      ids.forEach(id => restored.delete(id));
      removingIds.value = restored;
    }
  };

  return { isRemoving, removeWithFade };
}
